import { call, takeEvery, all, fork, select } from 'redux-saga/effects';
import { LOAD_WORKSPACES, SELECT_WORKSPACE, SET_AUTH_DATA, SIGNIN_USER_SUCCESS } from 'constants/ActionTypes';
import { fetchResource, getIntlMessage, loadEntities, showErrorMessage } from 'helpers/utilHelpers';
import { detectChangeWorkspace } from 'actions/entities/userActions';
import { authAliasSelector } from 'selectors/authSelectors';

function* fetchSelectWorkspace(action) {
  const { values } = action;
  try {
    const { alias } = yield call(fetchResource, 'workspaces/select', 'PUT', values);
    const stateAlias = yield select(authAliasSelector);
    if (alias !== stateAlias) {
      yield call(detectChangeWorkspace, alias);
      window.location.href = `/WS${alias}/home`;
    }
  } catch (ex) {
    showErrorMessage(getIntlMessage('user.workspace.select.error'));
  }
}

function detectAuthData(action) {
  const alias = action.data.alias;
  if (alias) {
    window.location.href = `/WS${alias}/home`;
  }
}

function* setAuthData() {
  yield takeEvery([SIGNIN_USER_SUCCESS, SET_AUTH_DATA], detectAuthData);
}

function* loadWorkspaces() {
  yield takeEvery(LOAD_WORKSPACES, loadEntities);
}

function* selectWorkspaces() {
  yield takeEvery(SELECT_WORKSPACE, fetchSelectWorkspace);
}

export default function* rootSaga() {
  yield all([fork(loadWorkspaces), fork(selectWorkspaces), fork(setAuthData)]);
}
